/** @jsxImportSource @emotion/react */

import { css } from '@emotion/react';

import { Theme as MaterialTheme, useTheme, Typography, Container, Box, Button, TextField, alpha } from "@mui/material";
import Grid from '@mui/material/Unstable_Grid2';
import { useState, } from "react";

import { useTranslation } from 'react-i18next';
import { toast,} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Link, useNavigate, useLocation , useParams } from 'react-router-dom';

import MainLogo from "../images/digiacc.png";
import Wallpaper from "../images/acc4.jpg";
import AuthenticationService from '../../service/AuthenticationService';
import { IAuthenticationModel } from '../../service/model/IAuthenticationModel';
import axios from 'axios';
import { saveTokenToLocalStorage } from '../../App';

const logoMain = css({
    height: "2.2rem",
})

const LoginRoute = (): JSX.Element => {

    const location = useLocation();

    const theme = useTheme();

    const { t } = useTranslation();

    const navigate = useNavigate();

    const [loginInformation, setLoginInformation] = useState<IAuthenticationModel>();
    const [loginMessage, setLoginMessage] = useState<string>("");

    const [forgotPassword, setForgotPassword] = useState(false);
    const [newPasswordRequired, setNewPasswordRequired] = useState(false);

    //##########################################################################################################

    const postLoginButton = (event: React.FormEvent<HTMLFormElement>) => {

        event.preventDefault();
        const data = new FormData(event.currentTarget);

        const handleLogin = async () => {
            const loginService = new AuthenticationService();


            const resultNew = await loginService.postLogin(data.get("email") as string, data.get("password") as string);

            if (resultNew.hasErrors) {
                //toast(t("basic.loginError") + ": " + resultNew.errors.join(", "))
                if (resultNew.errors[0] === "Bad credentials") {
                    setLoginMessage(t("basic.loginWrong"));
                } else {
                    setLoginMessage(t("basic.loginError") + ": " + resultNew.errors.join(", "));
                }
            } else if (resultNew.value.mustChangePassword) {
                setNewPasswordRequired(true);
                setLoginMessage(t("basic.youMustChangePassword"));
            }
            else {
                setLoginInformation(resultNew.value);
                if (resultNew.value.mustChangePassword) {
                    setNewPasswordRequired(true);
                    setLoginMessage(t("basic.youMustChangePassword"))
                } else {
                    //#################New code
                    axios.defaults.headers.common['Authorization'] = "Bearer " + resultNew.value.token;
                    saveTokenToLocalStorage("Bearer " + resultNew.value.token);

                    const urlParams = new URLSearchParams(location.search);
                    const redirectTo = urlParams.get('redirect'); 

                    if (redirectTo) {
                        navigate(redirectTo); 
                    } else {
                        navigate("/firm/" + resultNew.value.defaultOrganizationId); 
                    }
                }
            }
        };

        if (data.get("email") && data.get("password")) {
            handleLogin();
        } else {
            setLoginMessage(t("basic.loginMissing"));
            toast(t("basic.loginMissing"))
        }
    }

    const postForgotPasswordButton = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        const data = new FormData(event.currentTarget);

        const handleForgotPassword = async () => {
            const loginService = new AuthenticationService();

            let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            let email = data.get("email") as string;

            if (re.test(email)) {

                const result = await loginService.postResetPasswordEmail(data.get("email") as string)

                if (result.hasErrors) {
                    toast(t("basic.loginError"));
                    setLoginMessage(t("basic.loginError"));
                } else {
                    toast(t("basic.forgotPasswordEmailOk"));
                    setLoginMessage(t("basic.forgotPasswordEmailOk"));
                    setForgotPassword(false);
                }

            } else {
                toast(t("basic.forgotPasswordEmailError"));
                setLoginMessage(t("basic.forgotPasswordEmailError"));
            }
        };
        handleForgotPassword();
    }

    const postChangePasswordButton = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        const data = new FormData(event.currentTarget);

        const handleChangePassword = async () => {
            const loginService = new AuthenticationService();

            const email = data.get("email") as string;
            const oldPassword = data.get("oldPassword") as string;
            const newPassword = data.get("newPassword") as string;
            const reNewPassword = data.get("reNewPassword") as string;

            let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

            if (re.test(email)) {

                if (oldPassword !== "" && newPassword !== "" && reNewPassword !== "") {
                    if (oldPassword === newPassword) {
                        toast(t("basic.oldAndNewPasswordMatch"));
                    }
                    else if (newPassword === reNewPassword) {

                        const result = await loginService.postLoginWithChange(email, oldPassword, newPassword);
                        if (result.hasErrors) {
                            toast(t("basic.loginError"));
                            if (result.value.passwordNotMeetingComplexityRequirements) {
                                toast(t("basic.newPasswordNotMeetingRequirements"));
                            }
                        } else if (result.value.passwordNotMeetingComplexityRequirements) {
                            toast(t("basic.newPasswordNotMeetingRequirements"));
                        } else {
                            toast(t("basic.passwordChangedSuccessfully"));
                            setLoginMessage(t("basic.passwordChangedSuccessfully"));
                            setNewPasswordRequired(false);
                        }
                    }
                    else {
                        toast(t("basic.passwordsNotIdentical"));
                    }

                }
                else {
                    toast(t("basic.loginMissing"));
                }

            } else {
                toast(t("basic.forgotPasswordEmailError"));
            }
        };
        handleChangePassword();
    }

    //########################################################################################
    //########################################################################################

    if (forgotPassword) {
        return <main>
            <Grid container direction="column"
                sx={{
                    width: "100%",
                    minHeight: "30rem",
                    height: "calc(100vh)",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundImage: "url(" + Wallpaper + ")",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "cover",
                    //"& .MuiDataGrid-columnHeaders": { backgroundColor: theme.palette.info.main, color: "white" },
                    //"& .MuiDataGrid-footerContainer": { backgroundColor: theme.palette.info.main, color: "white" }
                }}>
                <Container sx={{
                    bgcolor: alpha(theme.palette.background.paper, 0.9),
                    minHeight: "20rem",
                    padding: theme.spacing(4), borderRadius: theme.shape.borderRadius, border: 1,
                }} maxWidth="xs">
                    <Box sx={{
                        marginTop: "1rem",
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                    }}>
                        <Box
                            component={Button}
                            sx={{
                                display: "flex",
                                justifyContent: "center", alignItems: "center", width: "100%",
                            }}>
                            <img src={MainLogo} css={logoMain} />
                        </Box>
                        <Box component="form" onSubmit={postForgotPasswordButton} noValidate sx={{ marginTop: theme.spacing(1) }}>
                            <TextField
                                margin="normal"
                                required
                                fullWidth
                                id="email"
                                label={t('basic.email')}
                                name="email"
                                type="email"
                                autoComplete="email"
                                autoFocus />
                            <Button
                                onClick={() => {
                                    setLoginMessage("");
                                    setForgotPassword(false);
                                }}
                                variant="contained"
                                color="primary" sx={{ mt: theme.spacing(3), mb: theme.spacing(2), mr: theme.spacing(2) }}>
                                {t('basic.cancel')}
                            </Button>
                            <Button type="submit" variant="contained" color="secondary" sx={{ mt: theme.spacing(3), mb: theme.spacing(2)}}>
                                {t('basic.reset')}
                            </Button>
                        </Box>
                        <Box sx={{ margin: theme.spacing(4), }}>
                            <Typography color={theme.palette.error.main}>{loginMessage}</Typography>
                        </Box>
                    </Box>
                </Container>
            </Grid>
        </main>
    }
    if (newPasswordRequired) {
        return <main>
            <Grid container direction="column"
                sx={{
                    width: "100%",
                    minHeight: "30rem",
                    height: "calc(100vh)",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundImage: "url(" + Wallpaper + ")",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "cover",
                    //"& .MuiDataGrid-columnHeaders": { backgroundColor: theme.palette.info.main, color: "white" },
                    //"& .MuiDataGrid-footerContainer": { backgroundColor: theme.palette.info.main, color: "white" }
                }}>
                <Container sx={{
                    bgcolor: alpha(theme.palette.background.paper, 0.9),
                    minHeight: "20rem",
                    padding: theme.spacing(4), borderRadius: theme.shape.borderRadius, border: 1,
                }} maxWidth="xs">
                    <Box sx={{
                        marginTop: "1rem",
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                    }}>
                        <Box
                            component={Button}
                            sx={{
                                display: "flex",
                                justifyContent: "center", alignItems: "center", width: "100%",
                            }}>
                            <img src={MainLogo} css={logoMain} />
                        </Box>
                        <Box sx={{ marginTop: theme.spacing(3) }}>
                            <Typography color={theme.palette.error.main}>{t("basic.youMustChangePassword")}</Typography>
                        </Box>
                        <Box component="form" onSubmit={postChangePasswordButton} noValidate sx={{ marginTop: theme.spacing(1) }}>
                            <TextField
                                margin="normal"
                                required
                                fullWidth
                                id="email"
                                label={t('basic.email')}
                                name="email"
                                type="email"
                                autoComplete="email"
                                autoFocus />
                            <TextField
                                margin="normal"
                                required
                                fullWidth
                                id="oldPassword"
                                label={t('basic.oldPassword')}
                                name="oldPassword"
                                type="password"
                                autoComplete="old-password"
                                autoFocus />
                            <TextField
                                margin="normal"
                                required
                                fullWidth
                                name="newPassword"
                                label={t('basic.newPassword')}
                                type="password"
                                id="newPassword"
                                autoComplete="new-password" />
                            <TextField
                                margin="normal"
                                required
                                fullWidth
                                name="reNewPassword"
                                label={t('basic.reEnterNewPassword')}
                                type="password"
                                id="reNewPassword"
                                autoComplete="renew-password" />
                            <Typography color={theme.palette.error.main}>{loginMessage}</Typography>
                            <Button type="submit" fullWidth variant="contained" color="primary" sx={{ mt: theme.spacing(3), mb: theme.spacing(2) }}>
                                {t('basic.changePassword')}
                            </Button>
                        </Box>
                    </Box>
                </Container>
            </Grid>
        </main>
    }

    return <main>
        <Grid container direction="column"
            sx={{
                width: "100%",
                minHeight: "30rem",
                height: "calc(100vh)",
                alignItems: "center",
                justifyContent: "center",
                backgroundImage: "url(" + Wallpaper + ")",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                //"& .MuiDataGrid-columnHeaders": { backgroundColor: theme.palette.info.main, color: "white" },
                //"& .MuiDataGrid-footerContainer": { backgroundColor: theme.palette.info.main, color: "white" }
            }}>
            <Container sx={{
                bgcolor: alpha(theme.palette.background.paper, 0.9),
                minHeight: "20rem",
                padding: theme.spacing(4), borderRadius: theme.shape.borderRadius, border:1,
            }} maxWidth="xs">
                <Box sx={{
                    marginTop:"1rem",
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}>
                    <Box
                        component={Button}
                        sx={{
                            display: "flex",
                            justifyContent: "center", alignItems: "center", width: "100%",
                        }}>
                        <img src={MainLogo} css={logoMain} />
                    </Box>
                    <Box component="form" onSubmit={postLoginButton} noValidate sx={{ marginTop: theme.spacing(1) }}>
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            id="email"
                            label={t('basic.email')}
                            name="email"
                            type="email"
                            autoComplete="email"
                            autoFocus />
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            name="password"
                            label={t('basic.password')}
                            type="password"
                            id="password"
                            autoComplete="current-password" />
                        <Typography color={theme.palette.error.main}>{loginMessage}</Typography>
                        <Button type="submit" fullWidth variant="contained" color="primary" sx={{ mt: theme.spacing(3), mb: theme.spacing(2) }}>
                            {t('basic.login')}
                        </Button>
                    </Box>
                    <Box alignSelf="flex-start">
                        <Link to="#" onClick={() => { setForgotPassword(true); } }>
                            <Typography variant="body2">{t('basic.forgotPassword')}</Typography>
                        </Link>
                    </Box>
                </Box>
            </Container>
        </Grid>
    </main>

}
export default LoginRoute;